import { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router';
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';
import ScrollToTop from './layouts/dashboard/ScrollToTop';
import AllRoutes from './layouts/AllRoutes';
import { ToastContainer } from 'react-toastify';
import LoadingWrapper from './components/LoadingWrapper';
import { BrandLoader } from './components/BrandLoader/BrandLoader';
import AppWrapper from './AppWrapper';
import ToastDismissAllButton from './components/ToastDismissAllButton';
import NotificationSetup from './components/NotificationSetup';
import OrchestratorHydrator from './components/OrchestratorHydrator';

// BrowserRouter re-wraps its own setState in startTransition, so the post-payment redirect's
// flushSync cannot flush it - only Sync lanes are flushed. Setting this to 'false' makes those
// updates synchronous instead. Undefined here means the prop is not passed at all, which is the
// router's current behaviour; only the literal string 'false' changes anything.
const resolvedRouterUseTransitions = process.env.REACT_APP_ROUTER_USE_TRANSITIONS === 'false' ? false : undefined;

const App = () => {
	return (
		<AppWrapper>
			<HelmetProvider>
				<Router
					unstable_useTransitions={resolvedRouterUseTransitions}
				// future={{
				// 	v7_startTransition: true,
				// 	v7_relativeSplatPath: true,
				// 	v7_partialHydration: true,
				// }}
				>
					<Helmet>
						<title>
							Weight Loss and Longevity - ReadyRx
						</title>
						<meta name='description' content='ReadyRx is your partner in Weight Loss & Longevity. Items include: Compounded Semaglutide, Ozempic, Tirzepatide, Zepbound, NAD+, Glutathione, and Metformin.' />
					</Helmet>
					<ScrollToTop />
					<NotificationSetup />
					<OrchestratorHydrator />
					<Suspense fallback={<LoadingWrapper isLoading={true} fullPage dark />}>
						<AllRoutes />
					</Suspense>
					<div className="toast-stack-region">
						<ToastDismissAllButton />
						<ToastContainer
							position="top-right"
							autoClose={5000}
							hideProgressBar={false}
							newestOnTop={false}
							closeOnClick={false}
							closeButton={false}
							rtl={false}
							pauseOnFocusLoss
							draggable
							pauseOnHover
							theme="light"
							aria-label='Notification Container'
						/>
					</div>
				</Router>
			</HelmetProvider>
		</AppWrapper>
	);
};

export default App;